import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

export default function ColoredBarChart({
  data = [
    {
      name: "Page A",
      value: 4000,
      color: "blue",
    },
    {
      name: "Page B",
      value: 3000,
      color: "red",
    },
    {
      name: "Page C",
      value: 2000,
      color: "green",
    },
  ],
}) {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            backgroundColor: "rgba(0,0,0,0.7)",
            padding: "10px",
            border: "none",
            borderRadius: "5px",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "10px",
              height: "10px",
              backgroundColor: payload[0].payload.color,
            }}
          />
          <span
            style={{ color: "#FFFFFF" }}
          >{`${payload[0].payload.label} - ${payload[0].payload.value}`}</span>
        </div>
      );
    }

    return null;
  };

  return (
    <ResponsiveContainer width={"100%"} height={300}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="0" vertical={false} stroke="#F2F2F2" />
        <XAxis
          dataKey="name"
          stroke="#F2F2F2"
          tick={{ fill: "#000000", fontFamily: "Inter", fontSize: "10px" }}
        />
        <YAxis
          stroke="#F2F2F2"
          tick={{ fill: "#000000", fontFamily: "Inter", fontSize: "10px" }}
        />
        <Tooltip
          content={<CustomTooltip />}
          cursor={{ fill: "rgba(255, 255, 255, 0.2)" }}
        />
        <Bar dataKey="value" fill="#8884d8" barSize={31}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
